import HeroSlider from "@/components/home/HeroSlider";
import TrustBar from "@/components/home/TrustBar";
import LuxuryDetails from "@/components/home/LuxuryDetails";
import CategoriesBanner from "@/components/home/CategoriesBanner";
import ShowroomTeaser from "@/components/home/ShowroomTeaser";
import InteriorDesign from "@/components/home/InteriorDesign";
import MediaSection from "@/components/home/MediaSection";
import Testimonials from "@/components/home/Testimonials";
import FeaturedProject from "@/components/home/FeaturedProject";
import Reveal from "@/components/ui/Reveal";
import SEO, { ORGANIZATION_JSONLD, WEBSITE_JSONLD, LOCAL_BUSINESS_JSONLD } from "@/components/system/SEO";
import { useTranslation } from "react-i18next";

export default function Index() {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title={t("seo.home.title")}
        description={t("seo.home.description")}
        jsonLd={[ORGANIZATION_JSONLD, WEBSITE_JSONLD, ...LOCAL_BUSINESS_JSONLD]}
      />
      <HeroSlider />
      <TrustBar />
      <Reveal as="div" variant="up"><CategoriesBanner /></Reveal>
      <Reveal as="div" variant="fade"><ShowroomTeaser /></Reveal>
      <Reveal as="div" variant="up"><FeaturedProject /></Reveal>
      <Reveal as="div" variant="up"><InteriorDesign /></Reveal>
      <Reveal as="div" variant="fade"><Testimonials /></Reveal>
      <Reveal as="div" variant="fade"><MediaSection /></Reveal>
      <Reveal as="div" variant="fade"><LuxuryDetails /></Reveal>
    </>
  );
}
